module.exports = __webpack_public_path__ + "img/logo.b49b485a.png";